import {useEffect, useState} from 'react';
import {useBetween} from 'use-between';

import {MS_IN_MINUTE} from '/constant/time.constant';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {createIntervalTimer} from '/util/timer.util';

const useRefresher = () => {
  const [lastRender, setLastRender] = useState(
    getDateUtilDefaultInstance().getNow(),
  );

  useEffect(() => {
    const removeTimer = createIntervalTimer(() => {
      const currDate = getDateUtilDefaultInstance().getNow();

      // Update component state per specified delay to cause new render
      setLastRender(currDate);
    }, MS_IN_MINUTE);

    return removeTimer;
  }, []);

  return {
    __lastRender: lastRender,
  };
};

export const useSharedRefresher = () => useBetween(useRefresher);
